import React, { useState } from 'react';
import PostStatusIcon from '../../assets/icon/post-status.png';
import VisibilityIcon from '../../assets/icon/visibility-icon.png';
import CalendarIcon from '../../assets/icon/calendar-icon.png';

const SideBarPublish = ({
  postStatus,
  setPostStatus,
  visibility,
  setVisibility,
  publishDate,
  setPublishDate,
}) => {
  const [editingStatus, setEditingStatus] = useState(false);
  const [editingVisibility, setEditingVisibility] = useState(false);
  const [editingDate, setEditingDate] = useState(false);

  const formatDateDisplay = (date) => {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12;

    return `${month} ${day}, ${year} at ${hours}:${minutes} ${ampm}`;
  };

  const formatDateTimeLocal = (date) => {
    const pad = (n) => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  const editBtnStyle = {
    background: 'none',
    border: 'none',
    color: '#2563eb',
    cursor: 'pointer',
    fontSize: '14px',
    padding: '0',
    textDecoration: 'underline',
  };

  return (
    <div style={{ borderBottom: '1px solid #e5e7eb' }}>
      <div style={{ padding: '24px' }}>
        <h3
          style={{
            margin: '0 0 24px 0',
            fontSize: '13px',
            fontWeight: '600',
            color: '#9ca3af',
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
          }}
        >
          PUBLISH
        </h3>

        {/* STATUS */}
        <div style={{ marginBottom: '20px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '4px',
            }}
          >
            <img
              src={PostStatusIcon}
              style={{ width: '23px', height: '20px' }}
            />
            <span style={{ fontSize: '12px', color: '#6b7280' }}>Status:</span>
          </div>

          {!editingStatus ? (
            <div>
              <span style={{ fontSize: '15px', fontWeight: '500' }}>
                {postStatus}
              </span>{' '}
              <button
                style={editBtnStyle}
                onClick={() => setEditingStatus(true)}
              >
                Edit
              </button>
            </div>
          ) : (
            <div>
              <select
                value={postStatus}
                onChange={(e) => setPostStatus(e.target.value)}
                style={{ marginBottom: '8px' }}
              >
                <option value="draft">Draft</option>
                <option value="pending">Pending Review</option>
                <option value="published">Published</option>
              </select>
              <div>
                <button onClick={() => setEditingStatus(false)}>OK</button>{' '}
                <button onClick={() => setEditingStatus(false)}>Cancel</button>
              </div>
            </div>
          )}
        </div>

        {/* VISIBILITY */}
        <div style={{ marginBottom: '20px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '4px',
            }}
          >
            <img
              src={VisibilityIcon}
              style={{ width: '23px', height: '20px' }}
            />
            <span style={{ fontSize: '12px', color: '#6b7280' }}>
              Visibility:
            </span>
          </div>

          {!editingVisibility ? (
            <div>
              <span style={{ fontSize: '15px', fontWeight: '500' }}>
                {visibility}
              </span>{' '}
              <button
                style={editBtnStyle}
                onClick={() => setEditingVisibility(true)}
              >
                Edit
              </button>
            </div>
          ) : (
            <div>
              <select
                value={visibility}
                onChange={(e) => setVisibility(e.target.value)}
                style={{ marginBottom: '8px' }}
              >
                <option value="public">Public</option>
                <option value="private">Private</option>
              </select>
              <div>
                <button onClick={() => setEditingVisibility(false)}>OK</button>{' '}
                <button onClick={() => setEditingVisibility(false)}>
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>

        {/* PUBLISH DATE */}
        <div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '4px',
            }}
          >
            <img src={CalendarIcon} style={{ width: '23px', height: '20px' }} />
            <span style={{ fontSize: '12px', color: '#6b7280' }}>
              Published on:
            </span>
          </div>

          {!editingDate ? (
            <div>
              <span style={{ fontSize: '15px', fontWeight: '500' }}>
                {formatDateDisplay(publishDate)}
              </span>{' '}
              <button style={editBtnStyle} onClick={() => setEditingDate(true)}>
                Edit
              </button>
            </div>
          ) : (
            <div>
              <input
                type="datetime-local"
                value={formatDateTimeLocal(publishDate)}
                onChange={(e) => setPublishDate(new Date(e.target.value))}
                style={{ marginBottom: '8px' }}
              />
              <div>
                <button onClick={() => setEditingDate(false)}>OK</button>{' '}
                <button onClick={() => setEditingDate(false)}>Cancel</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SideBarPublish;
